import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

const MySlider = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const desktopImages = [
    { url: "https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/slider/sliders.png", link: "/shop-details/1068" },
    { url: "https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/slider/sliiider.png", link: "/shop-details/951" },
  ];

  const mobileImages = [
    { url: "https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/slider/slm.png", link: "/shop-details/951" },
    { url: "https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/slider/slm1.png", link: "/shop-details/1068" },
  ];

  const images = isMobile ? mobileImages : desktopImages;
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: isMobile,
  autoplaySpeed: 3000,
  arrows: true, // force arrows to show
    centerMode: false,      // important
  variableWidth: false,   // important
  appendDots: (dots) => (
    <div style={{ position: "absolute", bottom: 30, right: 10 }}>
      <ul style={{ margin: 0 }}>{dots}</ul>
    </div>
  ),
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "rgba(0,0,0,0.5)", borderRadius: "50%" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "rgba(0,0,0,0.5)", borderRadius: "50%" }}
      onClick={onClick}
    />
  );
}

  return (
    <Slider {...settings}>
      {images.map((slide) => (
        <div key={slide.url}>
          <img
            onClick={() => navigate(slide.link)}
            src={slide.url}
            alt="Slide"
            style={{
              width: isMobile?"120%" :"100%",
              height: "60vh",
              minHeight: "220px",
              objectFit: "cover",
              cursor: "pointer",
              marginLeft: isMobile ? "100px" : "0", 
            }}
          />
        </div>
      ))}
    </Slider>
  );
};

export default MySlider;
